import React from 'react';
import Layout from '@layout';
import Hero from './Hero';
import Intro from './Intro';
import Photos from './Photos';
import Bio from './Bio';
import News from './News';

export default function Home(props) {
  return (
    <Layout
      overlayNav
      {...props}
    >
      <Hero />
      <Intro />
      <Photos />
      <Bio />
      <News />
    </Layout>
  );
}
